import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Wait for user restoration to complete before checking
  await authService.ensureUserRestored();

  if (!authService.user()) {
    return router.createUrlTree(['/login']);
  }

  return true;
};
